import script from "./ModeloDocumento.vue?vue&type=script&lang=ts&setup=true"
export * from "./ModeloDocumento.vue?vue&type=script&lang=ts&setup=true"

import "./ModeloDocumento.vue?vue&type=style&index=0&id=47ec0504&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47ec0504"]])

export default __exports__